import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumVesselMainPurpose implements BaseEnumType {
  private static allValues: EnumVesselMainPurpose[] = []; // make sure this is top-most
  
  public static unknown = new EnumVesselMainPurpose(0, "Unknown", "enum_vessel_main_purpose_unknown");
  public static productionVessel = new EnumVesselMainPurpose(1, "ProductionVessel", "enum_vessel_main_purpose_production_vessel");
  public static caskVessel = new EnumVesselMainPurpose(2, "CaskVessel", "enum_vessel_main_purpose_cask_vessel");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumVesselMainPurpose.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnknown() { return this === EnumVesselMainPurpose.unknown; }
  public isProductionVessel() { return this === EnumVesselMainPurpose.productionVessel; }
  public isCaskVessel() { return this === EnumVesselMainPurpose.caskVessel; }

  public static getValues(): readonly EnumVesselMainPurpose[] {
    return EnumVesselMainPurpose.allValues;
  }

  public static getValuesExcept0(): readonly EnumVesselMainPurpose[] {
    return EnumVesselMainPurpose.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumVesselMainPurpose {
    const found = EnumVesselMainPurpose.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumVesselMainPurpose - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumVesselMainPurpose): EnumVesselMainPurpose {
    const found = name ? EnumVesselMainPurpose.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumVesselMainPurpose - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumVesselMainPurpose>): boolean {
    return this.key === other?.key;
  }
}